export { default } from './StoriesList';
